module.exports = __webpack_public_path__ + "static/day05-9e112a4fe73a2d67457258122a7c3270.png";